import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

export default function ProjectDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const fromProject = location.state?.fromProject || false;
  const [projects, setProjects] = useState([]);
  const [markdown, setMarkdown] = useState('');

  // Load all projects
  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/data/portfolio.json')
      .then(res => res.json())
      .then((data) => setProjects(data.projects))
      .catch((err) => console.error('Failed to load project.', err));
  }, []);

  // Load markdown when slug changes AND preplace the path with the public IP env dynamically, as markdown can serve only static content
  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/data/markdown/${slug}.MD`)
      .then(res => res.text())
      .then(rawMarkdown => {
        const fixedMarkdown = rawMarkdown.replace(
          /src="(\.\.\/)+/g,  // matches src="../../ or src="../ etc
          `src="${process.env.PUBLIC_URL}/`
        );
        setMarkdown(fixedMarkdown);
      })
      .catch(() => setMarkdown('# 404\nProject not found.'));
  }, [slug]);

  useEffect(() => {
    if (markdown) {
      // Defer scrolling slightly to let DOM update
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' }); // optional smooth scroll
      });
    }
  }, [markdown]);

  // Resize the projects sidebar 
  useEffect(() => {
    const resizer = document.getElementById('dragHandle');
    const sidebar = document.getElementById('resizableSidebar');
    let isResizing = false;

    const onMouseDown = (e) => {
      isResizing = true;
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    };

    const onMouseMove = (e) => {
      if (!isResizing) return;
      const newWidth = e.clientX;
      sidebar.style.width = `${Math.max(180, newWidth)}px`;
    };

    const onMouseUp = () => {
      isResizing = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    resizer.addEventListener('mousedown', onMouseDown);

    return () => {
      resizer.removeEventListener('mousedown', onMouseDown);
    };
  }, []);

  return (
  <div className="project-docs-wrapper">
    <div className="resizable-container">
      <aside className="projects-sidebar" id="resizableSidebar">
        <h3>Other Projects</h3>
        <button onClick={() => navigate('/projects')} className="braces-button">
          ← Back to Projects Page
        </button>
        <button
          onClick={() => fromProject && navigate(-1)}
          className={`braces-button${fromProject ? '' : ' disabled'}`}
          disabled={!fromProject}
        >
          ← Previous Project
        </button>
        <ul>
          {projects.map((project) => (
            <li key={project.slug}>
              <button
                className={`project-button ${project.slug === slug ? 'active' : ''}`}
                onClick={() =>
                  navigate(`/projects/${project.slug}`, { state: { fromProject: true } })
                }
              >
                {project.title}
              </button>
            </li>
          ))}
        </ul>
      </aside>

      <div className="resizer" id="dragHandle" />

      <main className="content">
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdown}</ReactMarkdown>
      </main>
    </div>
  </div>
);
}